import { Editors } from 'angular-slickgrid';
import { FieldDefinition } from '../field-definition';
import { GenericValidator } from '../../generic-form/model/generic-validator';
import { GenericFormField } from '../../generic-form/model/generic-field';
import { ValidationTypes } from '../../generic-form/enums/validation-types';
import { ControlTypes } from '../../generic-form/enums/control-types';
import { InputTypes } from '../../generic-form/enums/input-type';
import { ValidationConverterService } from '../../services/validation-converter.service';
import { BaseFieldBuilder } from './field-builder.base';

export class TextFieldBuilder extends BaseFieldBuilder {
  private validators: GenericValidator[] = [];
  private _required = false;

  constructor(key: string, label: string) {
    super(key, label, ControlTypes.Textbox);
    this._type = 'text';
  }

  required(): this {
    this._required = true;
    this.validators.push(new GenericValidator({ key: ValidationTypes.Required }));
    return this;
  }

  minLength(value: number): this {
    this.validators.push(new GenericValidator({ key: ValidationTypes.MinLength, value }));
    return this;
  }

  maxLength(value: number): this {
    this.validators.push(new GenericValidator({ key: ValidationTypes.MaxLength, value }));
    return this;
  }

  email(): this {
    this._type = InputTypes.Email;
    this.validators.push(new GenericValidator({ key: ValidationTypes.Email }));
    return this;
  }

  tel(): this {
    this._type = InputTypes.Tel;
    return this;
  }

  pattern(pattern: string): this {
    this.validators.push(
      new GenericValidator({ key: ValidationTypes.Pattern, value: pattern })
    );
    return this;
  }

  build(): FieldDefinition {
    const column = this.getBaseColumnConfig();
    const localizedLabel = this.getLocalizationKey();

    if (!this.readOnlyValue) {
      // Factory to create editor with validation
      column.createEditor = (localizationService: any) => {
        const validationConverter = new ValidationConverterService(localizationService);
        return {
          model: Editors.text,
          required: this._required,
          validator: validationConverter.toSlickGridValidator(
            this.validators,
            this._required,
            this._controlType
          ),
        };
      };
    }

    return {
      key: this.key,
      label: localizedLabel,
      column,
      fieldOptions: new GenericFormField({
        key: this.key,
        label: localizedLabel,
        controlType: this._controlType,
        type: this._type,
        required: this._required,
        validators: this.validators,
        hidden: this.hideInChildFormsValue,
        hiddenByDefault: this.hideByDefaultValue,
        readOnly: this.readOnlyValue,
        showReadOnlyInForm: this.showReadOnlyInFormValue,
        dependencies: this.dependencyRules.length ? this.dependencyRules : undefined,
        prefilter: this.prefilterOptions,
      }),
    };
  }
}
